import styled from "styled-components";

export const Container = styled.div`
  padding: 40px 0px;
  max-width: 1100px;
  margin: 0 auto;
  gap: 48px;
  width: 100%;
`;

export const Layout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 280px;
  gap: 40px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`;

export const Content = styled.article`
  color: ${(props) => props.theme.colors.black};
  font-size: 16px;
  line-height: 30px;
  overflow-wrap: anywhere;

  h1 {
    font-size: 36px;
    margin-bottom: 16px;
  }

  h2 {
    border-top: 1px solid #ddd;
    padding-top: 20px;
    margin-top: 32px;
    margin-bottom: 12px;
    font-size: 24px;
  }

  h3 {
    font-size: 22px;
    margin: 20px 0 12px;
    padding-top: 12.5px;
  }

  h4 {
    font-size: 19px;
    margin: 16px 0 12px;
    padding-top: 10px;
  }

  p {
    margin-bottom: 16px;
  }

  ul,
  ol {
    margin: 0 0 10px;
    padding-left: 15px;
  }

  li {
    margin: 3.5px 0;
  }

  a {
    text-decoration: underline;
    color: ${(props) => props.theme.colors.primary};
  }

  img {
    max-width: 100%;
    height: auto;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 16px;
    overflow-x: auto;
  }

  th,
  td {
    padding: 8px;
    border: 1px solid #ddd;
  }
`;

export const Sidebar = styled.aside`
  align-self: stretch;
  border-left: 1px solid #e5e5e5;
  padding-left: 32px;

  @media (max-width: 900px) {
    border-left: none;
    padding-left: 0;
    padding-top: 24px;
  }
`;

export const SidebarTitle = styled.h2`
  color: ${(props) => props.theme.colors.black};
  border-bottom: 1px solid #ddd;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  padding-bottom: 12px;
  margin-bottom: 16px;
`;

export const SidebarNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const SidebarLink = styled.a`
  color: ${(props) => props.theme.colors.bodyLight};
  font-size: 14px;
  line-height: 20px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    color: ${(props) => props.theme.colors.primary};
  }

  &.active {
    font-weight: 700;
    text-decoration: none;
    color: ${(props) => props.theme.colors.primary};
  }
`;

export const EmptyMessage = styled.p`
  color: ${(props) => props.theme.colors.bodyLight};
  font-size: 18px;
  line-height: 28px;
  text-align: center;
`;
